import React, { memo } from 'react';

const DocumentsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M19.2 0.001h-12.8c-1.76 0-3.184 1.44-3.184 3.2l-0.016 25.599c0 1.76 1.424 3.2 3.184 3.2h19.216c1.76 0 3.2-1.44 3.2-3.2v-19.2l-9.6-9.6zM22.4 25.6h-12.8v-3.2h12.8v3.2zM22.4 19.2h-12.8v-3.2h12.8v3.2zM17.6 11.2v-8.8l8.8 8.8h-8.8z"
        />
    </svg>
);

export default memo(DocumentsIcon);
